<wiz-vgroup width="100%" height="100%" padding="5px" class="section-container">
  <wiz-hgroup width="100%">
    <wiz-label [wizLabel]="'$.common.edit.$'" class="smallTitleLabel" width="100%"></wiz-label>
    <wiz-icon class="image-purple" (click)="hide()">close</wiz-icon>
  </wiz-hgroup>
  <wiz-vgroup height="100%" wizValidationContainer horizontalAlign="center" width="100%" padding=" 0 15px">
    <wiz-text-input
      width="100%"
      #tiCode
      wizDisabled="true"
      wizLabel="$.common.code.$"
    ></wiz-text-input>

    <wiz-translation-basic
      #tiLabel
      wizValidator
      [maxTranslation]="6"
      [wizLabel]="'$.common.label.$'"
      [wizPlaceholder]="'$.common.define.$'"
      [wizMaxChars]="50"
      width="100%"
    ></wiz-translation-basic>

    <wiz-translation-basic
      #tiDescription
      [wizMaxChars]="255"
      [wizTranslationMode]="'textarea'"
      [maxTranslation]="6"
      [wizLabel]="'$.common.description.$'"
      width="100%"
      height="80px"
    ></wiz-translation-basic>
  </wiz-vgroup>
  <wiz-hgroup width="100%" horizontalAlign="flex-end">
    <wiz-button [wizLabel]="'$.common.validate.$'" (wizClick)="validate()" [wizDisabled]="!isValidable"></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
